<template>

<v-dialog v-model="dialog" width="500px">
  <v-card>
    <p class=".title ma-2">Add a contact to Sales partner {{inpe.inpt_code }} </p>
    <v-form ref="addInpe" v-model="addInpeValid">
     <v-row no-gutters>
      <v-col class="ma-2">
       <v-text-field v-model="inpe.inpe_email" :rules="inpe_emailRules" label="Email address"></v-text-field>
      </v-col>
     </v-row>
     <v-row no-gutters>
      <v-col class="ma-2">
       <v-text-field v-model="inpe.inpe_naam" label="Name"></v-text-field>
      </v-col>
     </v-row>    
     <v-row no-gutters>
      <v-col class="ma-2">
       <v-text-field v-model="inpe.inpe_telefoon" label="Telephone"></v-text-field>
      </v-col>
     </v-row>   
    </v-form>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn class="primary mx-2" small @click="addInpe" :disabled="!addInpeValid">Save</v-btn>
      <v-btn color="primary"  small @click="dialog = false">Close</v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>
</template>

<script>
export default {
  data() { 
    return {
      dialog: false,
      addInpeValid: false,
      inpt_encrid: null,
      inpe_email: '',
      inpe_naam: '',
      inpe_telefoon: '',
      inpe: {},
      inpe_emailRules: [
          v => (v && v.length >= 3) || "An enail address is required"
      ]
    }
  },
  methods: {
    open(inpt_encrid) {
      this.$emit("showSnackbar");
      this.dialog = true;
      this.$axios
        .post("ares/json/ares/task/inpt/inpe/getInptToAddInpe.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "getInptToAddInpe"
          },
          getInptToAddInpe: {
            inpt_encrid: inpt_encrid
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          } else {
            this.inpe = res.data.getInptToAddInpe;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    addInpe() { 
      this.$axios
        .post("ares/json/ares/task/inpt/inpe/addInpe.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "addInpe"
          },
          addInpe: {
            inpt_encrid: this.inpe.inpt_encrid,
            inpe_email: this.inpe.inpe_email,
            inpe_naam:  this.inpe.inpe_naam,
            inpe_telefoon: this.inpe.inpe_telefoon
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          }  else { 

             if (res.data.addInpe.color == "success") { 
                setTimeout(() => { this.$router.reload('/task/inpt/onInpt/' + res.data.addInpe.inpt_encrid);  }, 2000);      
             }         
             this.$store.dispatch('setSnackbar', {
              showing: true,
              text: res.data.addInpe.text,
              color: res.data.addInpe.color
            }); 
            this.dialog = false;
          }
        })
    },
  }
}
</script>

